import GoogleAnalytics from 'react-ga';

import Notification from './Notification.js'
import Youtube from './youtube.js'
import Train from './train.js'
import IpInfo from './ipinfo.js';
import Vagalume from './vagalume.js'
import TimeoutHandler from './TimeoutHandler.js'
import ListUtils from './ListUtils.js';
import MobileIdentifier from './MobileIdentifier.js';
import User from './User.js';

let LOADING_TIME = 7000;
let SCROBBLING_TIME = 30000;

let Player = {
  countryCode: undefined,
  activePlayer: undefined,
  originalPlaylist: [],
  playlist: [],
  currentIndex: undefined,
  currentTrack: undefined,
  onStatusChange: undefined,
  onTrackLoaded: undefined,
  isVideo: undefined,
  repeat: false,
  isActive: false
};

let scrobble = () => {
  let track = Player.currentTrack;

  if (track && User.getId())
  {
    Train.scrobble({track, player: Player.activePlayer.type})
    .then(() => {
      GoogleAnalytics.event({
        category: 'Player',
        action: 'scrobble',
        label: `${track.artist} - ${track.track}`
      });
      Notification.show(`Scrobbled ${track.artist} - ${track.track}`, 'success');
    })
  }
};

let skipLongLoading = () => {
  Notification.show(`Skipping song`, 'warning')
  Player.nextTrack();
};

let trackFinished = () => {
  Player.pause();

  if (Player.repeat) {
    Player.loadTrack(Player.currentIndex);
  }
  else {
    Player.nextTrack();
  }
}

let skipBeforeEnd = () => {

  let activePlayer = Player.activePlayer;

  if (activePlayer && activePlayer.player.getDuration() > 0 && activePlayer.player.getCurrentTime() + 3 >= activePlayer.player.getDuration()) {
    trackFinished();
  }

};

let timeOuts = { 
  scrobble: {timeout: undefined, timeoutStart: undefined, timeoutRemaining: undefined, method: scrobble},
  skipLongLoading: {timeout: undefined, timeoutStart: undefined, timeoutRemaining: undefined, method: skipLongLoading}
};

let intervals = {
  skipBeforeEnd: {interval: undefined, method: skipBeforeEnd, duration: 500}
};

let status = () => {
  if (Player.activePlayer.paused === true)
    return 'paused';
  else if (Player.activePlayer.paused === false)
    return 'playing';
};

Player.discoverArtist = () => {
  let track = Player.currentTrack;

  if (track)
  {
    Train.discoverArtist({artist: track.artist, status: true})
    .then(() => {
      Notification.show(`Discovered ${track.artist}`, 'success')
    })
  }
};

Player.loveTrack = () => {
  let track = Player.currentTrack;

  if (track)
  {
    Train.loveTrack({track, player: Player.activePlayer.type, status: true})
    .then(() => {
      Notification.show(`Loved ${track.artist} - ${track.track}`, 'success')
    })
  }
};

Player.getLyrics = (track, cb) => {

  if (!track)
    track = Player.currentTrack;

  if (track) {
    Vagalume.searchLyrics(track.artist, track.track)
    .then((lyrics) => {
      Player.lyrics = lyrics;
      Player.onStatusChange();
      if (cb) {
        cb(lyrics);
      }
    })
    .catch((error) => {
      cb({lines: ['No lyrics available']});
    });
  } else {
    cb({lines: ['No lyrics available']});
  }

};

Player.filterPlaylist = (query) => {

  query = query.trim().toLowerCase();

  let originalPlaylist = Player.originalPlaylist;

  let playlist = originalPlaylist.filter((item) => {
    return item.originalTitle.toLowerCase().indexOf(query) > -1;
  });

  Player.playlist = playlist;

  return playlist;

};

Player.playOrPause = () => {
  if (Player.activePlayer) {
    if (Player.activePlayer.paused === true)
      Player.play();
    else if (Player.activePlayer.paused === false)
      Player.pause();

    return status();

  }
};

Player.play = () => {

  TimeoutHandler.resume(timeOuts['scrobble']);

  if (MobileIdentifier()) {
    TimeoutHandler.setInterval(intervals['skipBeforeEnd']);
  }

  if (Player.activePlayer)
    return Player.activePlayer.play();
};

Player.pause = () => {

  TimeoutHandler.pause(timeOuts['scrobble']);

  if (MobileIdentifier()) {
    TimeoutHandler.clearInterval(intervals['skipBeforeEnd']);
  }

  if (Player.activePlayer)
    return Player.activePlayer.pause();
};

Player.paused = () => {
  if (Player.activePlayer)
    return Player.activePlayer.paused;
};

Player.load = ({onStatusChangeCb, onTrackLoadedCb}) => {

  Player.onStatusChange = () => {
    onStatusChangeCb();
  };

  Player.onTrackLoaded = (track) => {
    onTrackLoadedCb(track);
  };

  IpInfo.fetchCountryCode()
  .then((countryCode) => Player.countryCode = countryCode);

  Youtube.load({
    onEndCb: trackFinished, 
    onPlayCb: Player.play.bind(this),
    onPauseCb: Player.pause.bind(this),
    onStatusChangeCb: (state) => {
      Player.isActive = true;
      if (state === window.YT.PlayerState.PLAYING) {
        TimeoutHandler.stop(timeOuts['skipLongLoading']);
      }
      onStatusChangeCb();
  }});

  Player.activePlayer = Youtube;

  Player.isVideo = Player.activePlayer.isVideo

};

Player.searchTracks = ({type = 'artist', terms = []}) => {
  
  terms = terms.map((element) => {
    
    let item = {};

    if (element.artist)
      item.artist = element.artist;

    if (element.track)
      item.track = element.track;

    if (element.album)
      item.album = element.album;

    if (element.user)
      item.user = element.user;

    if (element.tag)
      item.tag = element.tag;

    if (element.lastfmUser)
      item.lastfmUser = element.lastfmUser;

    if (element.popular)
      item.popular = element.popular;

    return item;
    
  });

  let max = 100;

  if (type !== 'artist')
    max = 50;

  terms = ListUtils.shuffle(terms).slice(0, max);

  Notification.show('Player is searching for tracks...', 'info');
  return Train.fetchPlayerTracks({
    countryCode: Player.countryCode,
    player: Player.activePlayer.type,
    type: type,
    terms: terms
  })
  .then((result) => { 
    Player.originalPlaylist = result.tracks;
    Player.playlist = Player.originalPlaylist;  
    Player.loadPlaylist();
    return Player.playlist;
  })
  .catch((error) => {
    Notification.show('Player did not find songs', 'error');
  });

};

Player.loadPlaylist = () => {
  if (Player.playlist.length === 0) {
    Player.currentIndex = undefined;
    Player.currentTrack = undefined;
  } else {
    Player.currentIndex = 0;
    Player.currentTrack = Player.playlist[0];
    Player.loadTrack(Player.currentIndex);
  }
};

Player.previousTrack = () => {

  TimeoutHandler.stop(timeOuts['scrobble']);
  TimeoutHandler.stop(timeOuts['skipLongLoading']);

  if (Player.repeat) {
    Player.loadTrack(Player.currentIndex);
  } else if (Player.playlist.length > 0) {

    if (Player.currentIndex - 1 >= 0) 
      Player.currentIndex -= 1;
    else
      Player.currentIndex = Player.playlist.length - 1;

    Player.currentTrack = Player.playlist[Player.currentIndex];
    Player.loadTrack(Player.currentIndex);
  }

};

Player.nextTrack = () => {

  TimeoutHandler.stop(timeOuts['scrobble']);
  TimeoutHandler.stop(timeOuts['skipLongLoading']);

  if (Player.repeat) {
    Player.loadTrack(Player.currentIndex);
  } 
  else if (Player.playlist.length > 0) {
    Player.currentIndex = (Player.currentIndex + 1) % Player.playlist.length;
    Player.currentTrack = Player.playlist[Player.currentIndex];
    Player.loadTrack(Player.currentIndex);
  }

};

Player.loadTrack = (index) => {

  let currentTrack = Player.playlist[index];

  Player.currentTrack = currentTrack;
  Player.currentIndex = index;

  Player.onTrackLoaded(currentTrack);

  Player.activePlayer.loadTrack(currentTrack);

  timeOuts['scrobble'].timeoutRemaining = SCROBBLING_TIME;
  timeOuts['skipLongLoading'].timeoutRemaining = LOADING_TIME;
  TimeoutHandler.start(timeOuts['scrobble']);
  

  if (!MobileIdentifier() || Player.isActive) {
    TimeoutHandler.start(timeOuts['skipLongLoading']);
  }

  Player.onStatusChange();

  let song = `${currentTrack.artist} - ${currentTrack.track}`;
  document.title = `${song} - Spicy Mocha`;

  GoogleAnalytics.event({
    category: 'Player',
    action: 'loaded',
    label: song
  });


};

Player.shuffle = () => {

  Player.originalPlaylist = ListUtils.shuffle(Player.originalPlaylist);
  Player.playlist = ListUtils.shuffle(Player.playlist);
  Player.currentIndex = Player.playlist.indexOf(Player.currentTrack);

};

Player.toggleRepeat = () => {
  Player.repeat = !Player.repeat;
};

module.exports = Player



// WEBPACK FOOTER //
// ./src/js/services/player.js